import type { Table } from '@features/tables/models'
import { Path } from '@/routes/paths'

export function getTablesInDropdownOrder(tables: Table[]): Table[] {
  return [...tables].sort((a, b) =>
    a.display_name_singular.localeCompare(b.display_name_singular, undefined, {
      sensitivity: 'base',
    })
  )
}

/**
 * The table Tables opens on: the first in dropdown order that the user hasn't
 * hidden from the sidebar (`hiddenPaths`), or the first of all when every
 * table is hidden.
 */
export function getTableToOpen(
  tables: Table[],
  hiddenPaths: ReadonlySet<string>
): Table | undefined {
  const ordered = getTablesInDropdownOrder(tables)
  return ordered.find((table) => !hiddenPaths.has(Path.tableRecords(table.id))) ?? ordered[0]
}
